import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f8ccddc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "Search_item" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Search_item_label" }, "检验日期", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_5 = { class: "Search_item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Search_item_label" }, "检验类型", -1))
const _hoisted_7 = { class: "Search_item_content" }
const _hoisted_8 = { class: "tag" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "Search_item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Search_item_label" }, "检验工序", -1))
const _hoisted_12 = { class: "Search_item_content" }
const _hoisted_13 = { class: "tag" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "Search_item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Search_item_label" }, "批次号", -1))
const _hoisted_17 = { class: "Search_item_content" }
const _hoisted_18 = { class: "content_total" }
const _hoisted_19 = { class: "content_list" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "content_list_item_title" }
const _hoisted_22 = {
  key: 0,
  class: "warning"
}
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  key: 2,
  class: "green"
}
const _hoisted_25 = { class: "content_list_item_nr" }
const _hoisted_26 = { class: "content_list_item_nr_box" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "物料信息：", -1))
const _hoisted_28 = {
  key: 0,
  class: "cr"
}
const _hoisted_29 = { class: "content_list_item_nr_boxs" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "生产数量：", -1))
const _hoisted_31 = {
  key: 0,
  class: "cr"
}
const _hoisted_32 = { class: "content_list_item_nr_box" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "生产批次：", -1))
const _hoisted_34 = { class: "cr" }
const _hoisted_35 = { class: "content_list_item_nr_boxs" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "生产工序：", -1))
const _hoisted_37 = {
  key: 0,
  class: "cr"
}
const _hoisted_38 = { class: "content_list_item_nr_box" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "工单编号：", -1))
const _hoisted_40 = { class: "cr" }
const _hoisted_41 = { class: "content_list_item_nr_boxs" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "检验人员：", -1))
const _hoisted_43 = { class: "cr" }
const _hoisted_44 = { class: "content_list_item_nr_box" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "合格数量：", -1))
const _hoisted_46 = {
  key: 0,
  class: "cr"
}
const _hoisted_47 = { class: "content_list_item_nr_boxs" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "不良数量：", -1))
const _hoisted_49 = {
  key: 0,
  class: "cr warning"
}

import { reactive, ref, onMounted } from "vue"
    import { useRouter, useRoute } from "vue-router"
    import { useStore } from "vuex"
    import { gsdate, judgmentPlatform } from '@/utils/utils'
    import { page } from '@/apis/QualityAPI'
    import { getWorkingProcedure, deletejy } from "@/apis/PlanningAPI"
    import { model } from '@/interface'
    import vSearch from '@/components/common/Search.vue'
    import vLableSelection from '@/components/common/LabelSelection.vue'

    interface page extends model {
        total: number,
        checkStartDate: string,
        checkEndDate: string,
        minParam: any,
        batch: string | number,
        checkType: string,
        procedureId: string,
        workorderId: string
    }

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const store = useStore()

    const route = useRoute()

    const router = useRouter()

    // 分页查询数据
    const pageData = reactive<page>({
        capacity: 10,
        page: 0,
        total: 0,
        checkStartDate: '',
        checkEndDate: '',
        minParam: '',
        batch: '',
        checkType: '',
        procedureId: '',
        workorderId: route.query.id ? route.query.id as string : ''
    })

    const minDate: Date = new Date(2021, 0, 1)

    const maxDate: Date = new Date(new Date().getFullYear() + 1, 12, 30)

    let status = ref<boolean>(false)    // 根据平台是否需要设置top

    // 列表数据
    let listData: any = ref([])

    const openCode = ref<boolean>(false)

    // 检验类型
    let data: any = reactive([
        { id: '0', name: '巡线', isActive: false },
        { id: '1', name: '巡检', isActive: false },
        { id: '2', name: '完工检', isActive: false }
    ])

    // 检验工序
    let workingProcedure: any = reactive([])

    const isOpenDate = ref(false)

    const list: any = ref([])
    const loading = ref(false)
    const finished = ref(false)
    const refreshing = ref(false)

    // 删除检验记录
    const dele = (id: string | number): void => {
        deletejy(id)
            .then(res => {
                if (res.code === 200) {
                    listData.value = []
                    pageData.page = 0
                    finished.value = false
                    onLoad()
                }
            })
    }

    // 重置
    const reset = () => {
        pageData.checkStartDate = ''
        pageData.checkEndDate = ''
        pageData.minParam = ''
        pageData.checkType = ''
        pageData.procedureId = ''
        pageData.batch = ''
        pageData.page = 0
        listData.value = []
        finished.value = false
        data.forEach((item: any) => { item.isActive = false })
        workingProcedure.forEach((item: any) => { item.isActive = false })
        onLoad()
    }

    // 查询搜索
    const searchInput = (val: any) => {
        pageData.minParam = val
        pageData.page = 0
        listData.value = []
        finished.value = false
        onLoad()
    }

    // 搜索提交
    const submit = () => {
        data.forEach((item: any) => {
            if (item.isActive) {
                pageData.checkType = item.id
            }
        })
        workingProcedure.forEach((item: any) => {
            if (item.isActive) {
                pageData.procedureId = item.id
            }
        })
        pageData.page = 0
        listData.value = []
        finished.value = false
        onLoad()
    }

    // 跳转详情
    const jumpDesc = (item: any) => {
        router.push({ name: 'details', query: { id: item.id } })
    }

    // 打开日期选择组件
    const openDate = () => {
        isOpenDate.value = true
    }

    // 打开扫码组件
    const openScanCode = () => {
        openCode.value = true
    }

    // 关闭扫码组件
    const closePopup = (): void => {
        openCode.value = false
    }

    // 日期确认
    const onConfirm = (values: any) => {
        const [start, end] = values
        pageData.checkStartDate = gsdate(start)
        pageData.checkEndDate = gsdate(end)
        isOpenDate.value = false
    }

    // 切换检类型
    const changeTag = (i: any): void => {
        data.forEach((item: { isActive: boolean; }, index: any) => {
            item.isActive = index === i;
        })
    }

    // 切换检工序
    const changeTag1 = (i: any): void => {
        workingProcedure.forEach((item: { isActive: boolean; }, index: any) => {
            item.isActive = index === i;
        })
    }

    // 获取扫码值
    const onDecode = (data: string[]): void => {
        console.log(data)
    }

    // 获取当前用户所分配的工序
    const getWorkingProcedures = async () => {
        let res = await getWorkingProcedure({
            capacity: 100,
            page: 1,
            model: {
                userId: store.state.userInfo.id
            }
        })
        if (res.code === 200 && res.data.records.length !== 0) {
            res.data.records.forEach((item: any, index: number) => {
                // if (index === 0) {
                //     workingProcedure.push({ id: item.id, name: item.name, isActive: true })
                // } else {
                    workingProcedure.push({ id: item.id, name: item.name, isActive: false })
                // }
            })
        }
    }

    // 列表
    const onLoad = () => {
        if (!finished.value) {
            pageData.page = pageData.page + 1
            loading.value = true
            page({
                capacity: pageData.capacity,
                page: pageData.page,
                model: {
                    minParam: pageData.minParam,
                    checkStartDate: pageData.checkStartDate,
                    checkEndDate: pageData.checkEndDate,
                    checkType: pageData.checkType,
                    procedureId: pageData.procedureId,
                    workorderId: pageData.workorderId
                }
            }).then(res => {
                if (refreshing.value) {
                    listData.value = []
                    refreshing.value = false;
                }
                loading.value = false
                if (res.code === 200 && res.data.records && res.data.records.length !== 0) {
                    pageData.total = res.data.total
                    listData.value.push(...res.data.records)
                } else {
                    finished.value = true
                }
            }).catch(err => {
                loading.value = false
                finished.value = true
                if (refreshing.value) {
                    listData.value = []
                    refreshing.value = false;
                }
            })
        }
    }

    // 下拉刷新优化页面
    const onRefresh = () => {
        finished.value = false;
        pageData.page = 0
        loading.value = true;
        onLoad();
    }

    onMounted(() => {
        status.value = judgmentPlatform()
        getWorkingProcedures()
    })

return (_ctx: any,_cache: any) => {
  const _component_van_swipe_cell = _resolveComponent("van-swipe-cell")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_calendar = _resolveComponent("van-calendar")!
  const _component_v_ScanCode = _resolveComponent("v-ScanCode")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{ 'content_top': _unref(status) }, "content_search"])
    }, [
      _createVNode(vSearch, {
        placeholder: "搜索工单编号/物料编码",
        onSearchInput: searchInput,
        onSubmit: submit,
        onReset: reset,
        isShow: true
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", {
              class: "Search_item_content",
              onClick: openDate
            }, [
              _createElementVNode("div", {
                class: "Search_item_content_a",
                style: _normalizeStyle(_unref(pageData).checkStartDate ? 'color: #000;' : '')
              }, _toDisplayString(_unref(pageData).checkStartDate ? _unref(pageData).checkStartDate : '开始日期'), 5),
              _hoisted_4,
              _createElementVNode("div", {
                class: "Search_item_content_a",
                style: _normalizeStyle(_unref(pageData).checkEndDate ? 'color: #000;' : '')
              }, _toDisplayString(_unref(pageData).checkEndDate ? _unref(pageData).checkEndDate : '结束日期'), 5)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["tag_item", {'tag_active': item.isActive}]),
                    key: item.id,
                    onClick: ($event: any) => (changeTag(i))
                  }, _toDisplayString(item.name), 11, _hoisted_9))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(workingProcedure), (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["tag_item", {'tag_active': item.isActive}]),
                    key: item.id,
                    onClick: ($event: any) => (changeTag1(i))
                  }, _toDisplayString(item.name), 11, _hoisted_14))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "请输入批次号",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(pageData).batch) = $event))
              }, null, 512), [
                [_vModelText, _unref(pageData).batch]
              ])
            ])
          ])
        ]),
        _: 1
      })
    ], 2),
    _createElementVNode("div", _hoisted_18, "共" + _toDisplayString(_unref(pageData).total) + "条数据", 1),
    _createVNode(_component_van_pull_refresh, {
      modelValue: refreshing.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((refreshing).value = $event)),
      onRefresh: onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: loading.value,
          "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => ((loading).value = $event)),
          finished: finished.value,
          "finished-text": "没有更多了~",
          onLoad: onLoad
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listData), (item, i) => {
                return (_openBlock(), _createBlock(_component_van_swipe_cell, { key: i }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "content_list_item",
                      onClick: ($event: any) => (jumpDesc(item))
                    }, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("span", null, _toDisplayString(item.code), 1),
                        (item.checkType === 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, "巡线"))
                          : _createCommentVNode("", true),
                        (item.checkType === 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, "巡检"))
                          : _createCommentVNode("", true),
                        (item.checkType === 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, "完工检"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _hoisted_27,
                          (item.mmodel)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(item.mmodel.name) + "丨" + _toDisplayString(item.mmodel.code), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _hoisted_30,
                          (item.umodel)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(item.num) + _toDisplayString(item.umodel.name), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _hoisted_33,
                          _createElementVNode("div", _hoisted_34, _toDisplayString(item.batch), 1)
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _hoisted_36,
                          (item.pmodel)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(item.pmodel.name), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _hoisted_39,
                          _createElementVNode("div", _hoisted_40, _toDisplayString(item.workorderCode), 1)
                        ]),
                        _createElementVNode("div", _hoisted_41, [
                          _hoisted_42,
                          _createElementVNode("div", _hoisted_43, _toDisplayString(item.smodelRealName) + "/" + _toDisplayString(item.checkUserDepartName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_44, [
                          _hoisted_45,
                          (item.umodel)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(item.qualifiedNum) + _toDisplayString(item.umodel.name), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _hoisted_48,
                          (item.umodel)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(item.unqualifiedNum) + _toDisplayString(item.umodel.name), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 8, _hoisted_20)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["loading", "finished"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_van_calendar, {
      show: isOpenDate.value,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((isOpenDate).value = $event)),
      "min-date": _unref(minDate),
      "max-date": _unref(maxDate),
      type: "range",
      color: "#4275FC",
      onConfirm: onConfirm
    }, null, 8, ["show", "min-date", "max-date"]),
    _createVNode(_component_v_ScanCode, {
      openCode: openCode.value,
      infos: ['第一次扫码'],
      onClosePopup: closePopup,
      onOnDecode: onDecode
    }, null, 8, ["openCode"])
  ]))
}
}

})